import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface OnboardingContextType {
  isOnboardingActive: boolean;
  setOnboardingActive: (active: boolean) => void;
}

const OnboardingContext = createContext<OnboardingContextType>({
  isOnboardingActive: false,
  setOnboardingActive: () => {},
});

interface OnboardingProviderProps {
  children: ReactNode;
}

export function OnboardingProvider({ children }: OnboardingProviderProps) {
  const [isOnboardingActive, setIsOnboardingActive] = useState(false);

  const setOnboardingActive = (active: boolean) => {
    setIsOnboardingActive(active);
  };

  return (
    <OnboardingContext.Provider
      value={{
        isOnboardingActive,
        setOnboardingActive,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
}

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext deve ser usado dentro de OnboardingProvider');
  }
  return context;
};
